import { useEffect, useState } from 'react';
import { client } from '../lib/sanity';
import Welcome from '../components/Welcome';
import CategoryNav from '../components/CategoryNav';
import Gallery from '../components/Gallery';
import About from '../components/About';

function Home() {
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "category" && count(*[_type == "artwork" && references(^._id)]) > 0]
           | order(order asc) {
             _id, name, "slug": slug.current, intro
           }`
      )
      .then((cats) => {
        setCategories(cats);
        if (cats.length > 0) setActiveCategory(cats[0].slug);
      });
  }, []);

  // The nav links to /#collections and /#about. Those sections only exist once
  // the categories have loaded, so the browser's own hash scrolling is too early.
  // Plain scrollIntoView on purpose: smooth scrolling is silently unavailable in
  // some browsers, and a jump is what a normal anchor link does anyway.
  useEffect(() => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id || categories.length === 0) return;
    document.getElementById(id)?.scrollIntoView();
  }, [categories]);

  const activeCategoryIntro =
    categories.find((c) => c.slug === activeCategory)?.intro;

  return (
    <>
      <Welcome />
      <hr className="category-divider-line" />
      <CategoryNav
        categories={categories}
        active={activeCategory}
        onChange={setActiveCategory}
      />
      {activeCategory && (
        <Gallery categorySlug={activeCategory} intro={activeCategoryIntro} />
      )}
      <About />
    </>
  );
}

export default Home;
